<template>
  <div class="typographic-scale-content" id="identidade-visual-tipografia-escala-tipografica" data-search-anchor>
    <div class="title-typographic-scale-wrapper">
      <h1 class="typographic-scale-span">{{ typographyTypographicScaleTitleSpan }}</h1>
      <h1 class="typographic-scale-title">{{ typographyTypographicScaleTitle }}</h1>
    </div>
    <div class="description-typographic-scale-wrapper">
      <div>
        <p class="typographic-scale-description">{{ typographyTypographicScaleDescription }}</p>
        <p class="typographic-scale-description">
          {{ typographyTypographicScaleDescription1 }}
        </p>
      </div>

      <div class="typographic-scale-icon">
        <IconCheck />
        <p class="typographic-scale-description2">{{ typographyTypographicScaleDescription2 }}</p>
      </div>
    </div>
    <div
      class="typographic-scale-card-item" style="margin-bottom: 1rem;"
      :style="{ backgroundImage: `url(${typographyTypographicScaleImageSrc})` }"
    ></div>
    <div
      class="typographic-scale-card-item"
      :style="{ backgroundImage: `url(${typographyTypographicScaleImageSrc2})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import TypographyPageMixin from '@/mixins/typography-page-mixin'
import { TypographyPageStore } from '@/store/visual-identity-page/typography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class TypographyTypographicScaleSection extends Mixins(TypographyPageMixin) {
  typographyPageStore: PageStoreContract = getModule(TypographyPageStore, this.$store)

  get typographyTypographicScaleTitleSpan(): string {
    return this.getElementTitle(3, 0)
  }

  get typographyTypographicScaleTitle(): string {
    return this.getElementText(3, 0)
  }

  get typographyTypographicScaleDescription(): string {
    return this.getElementText(3, 1)
  }

  get typographyTypographicScaleDescription1(): string {
    return this.getElementText(3, 2)
  }

  get typographyTypographicScaleDescription2(): string {
    return this.getElementText(3, 3)
  }

  get typographyTypographicScaleImageSrc(): string {
    return this.getElementMedia(3, 4)
  }

  async getTypographyPage(): Promise<void> {
    await this.typographyPageStore.getDataPage()
  }

  get typographyTypographicScaleImageSrc2(): string {
    return this.getElementMedia(3, 5)
  }

  async mounted(): Promise<void> {
    if (!this.typographyPageStore.isLoading) {
      await this.getTypographyPage()
    }
  }
}
</script>

<style lang="scss">
.typographic-scale-content {
  display: grid;
  width: 100%;
}

.title-typographic-scale-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-bottom: 1rem;
}

.typographic-scale-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.typographic-scale-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.typographic-scale-icon {
  display: flex;
  align-items: center;
  margin-bottom: 6rem;
}

.description-typographic-scale-wrapper { 
  position: relative;  
  align-items: flex-start;
  display: grid;
  grid-template-columns: 50% 50%;  
}

.typographic-scale-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  
  width: 430px;
}

.typographic-scale-description2 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  
  width: 378px;
  padding-left: 7px;
}

.typographic-scale-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 710px;
  border-radius: 8px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
